import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { NumberInput, TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"

function FrequencesFields({ item, set }) {
    const t = useTranslations()
    return <>
        <Row>
            <TextInput className="grow" label={t("Texte FR")} value={item.textFr} onChange={set('textFr')} required />
            <TextInput className="grow" label={t("Texte NL")} value={item.textNl} onChange={set('textNl')} required />
            <TextInput className="grow" label={t("Texte EN")} value={item.textEn} onChange={set('textEn')} required />
        </Row>
        <Row>
            <NumberInput label={t("Ordre")} value={item.ordre} onChange={set('ordre')} required />
        </Row>
    </>
}

export function FrequencesList(props) {
    const t = useTranslations()
    return <ListPage model="frequences" title={t("Fréquences")} columns={{
        [t('Ordre')]: 'ordre',
        [t('Texte FR')]: 'textFr',
        [t('Texte NL')]: 'textNl',
        [t('Texte EN')]: 'textEn',
    }} {...props} />
}

export function FrequencesDetail(props) {
    const t = useTranslations()
    return <DetailPage model="frequences" title={t("Fréquence")} Fields={FrequencesFields} defaults={{ ordre: 99 }} {...props} />
}
